type End = 'end' | 'start';

// If the input is not a valid side, we assume it's `start`
export default function getOppositeEnd(input: End | string): End {
  return input === 'end' ? 'start' : 'end';
}
